import { useQuery } from "@tanstack/vue-query";
import { computed, unref } from "vue";

import { hasDisplayStudentDiscountEnabled } from "@/composables/authorization";
import ordersService from "@/services/orders";

export const useGetOrderPricing = ({ priceBreakDownAllowed, sessionId, order = {} }) => {
  const { isLoading: isLoadingPriceBreakdownFromOrderPricing, data: priceBreakDownDataFromOrderPricing } = useQuery({
    queryKey: computed(() => [
      "fetchPriceBreakdownFromOrderPricing",
      order.id,
      hasDisplayStudentDiscountEnabled.value ? order?.special_pricing_override_entity_id : undefined,
    ]),
    queryFn: async () =>
      await ordersService.getOrdersPricing({
        payload: {
          id: order?.id,
          session_id: sessionId,
          ...(hasDisplayStudentDiscountEnabled.value
            ? { special_pricing_override_entity_id: order?.special_pricing_override_entity_id }
            : {}),
        },
      }),
    enabled: priceBreakDownAllowed,
  });

  const isLoadingPriceBreakdown = computed(() => unref(isLoadingPriceBreakdownFromOrderPricing));

  const priceBreakDownData = computed(() => unref(priceBreakDownDataFromOrderPricing)?.data?.data ?? {});

  return {
    isLoadingPriceBreakdown,
    priceBreakDownData,
  };
};
